module.exports = __webpack_public_path__ + "static/media/help_time.a3c384a4.svg";